import React, { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import { PieChart, Pie, Sector, ResponsiveContainer } from "recharts";
import { getRandomInt } from "../../api/api";

const data = [
  { name: "Qatar", value: 6613 },
  { name: "United Arab Emirates", value: 3540 },
  { name: "Oman", value: 986 },
  { name: "Saudi Arabia", value: 827 },
  { name: "United States", value: 220 },
];

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    value,
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={"#fff"}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={"#fff"}
      />
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill="none"
      />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        textAnchor={textAnchor}
        fill="#fefefe"
      >{`${value} Users`}</text>
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        dy={18}
        textAnchor={textAnchor}
        fill="#f5f5f5"
      >
        {`(Rate ${(percent * 100).toFixed(2)}%)`}
      </text>
    </g>
  );
};

const CountryPie = (props) => {
  const [activeIndex, setIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  // Check if the data is loaded after 1.5 seconds, simulating an async data load
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500); // Wait for 1.5s to simulate loading
    return () => clearTimeout(timer); // Cleanup timer if component is unmounted
  }, []);

  const onPieEnter = (_, index) => {
    setIndex(index);
  };

  // Determine which data to use for rendering the PieChart
  const chartData = props.info || props.data || data;
  console.log("in piechart", props);
  return (
    <div style={{ width: "100%", height: 300 }}>
      {loading ? (
        <div className="center" style={{ textAlign: "center" }}>
          <Loader type="TailSpin" color="#15b4de" height={300} width={"10%"} />
        </div>
      ) : (
        <ResponsiveContainer>
          <PieChart>
            <Pie
              activeIndex={activeIndex}
              activeShape={renderActiveShape}
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius={80}
              outerRadius={100}
              fill={COLORS[getRandomInt(COLORS.length)]} // Ensure it's within bounds of the array
              dataKey={props.data ? "total" : "value"}
              onMouseEnter={onPieEnter}
            />
          </PieChart>
        </ResponsiveContainer>
      )}
      {chartData.length === 0 && !loading && (
        <div
          className="text-center"
          style={{ height: 300, display: "grid", placeItems: "center" }}
        >
          <h5 className="text-white">No Device Based Users</h5>
        </div>
      )}
    </div>
  );
};

export default CountryPie;
